

































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { ProgramChain } from "@/data/models/ProgramChain";
import CreateProgramChainNoteComponent from "./CreateProgramChainNote.vue";
import { ProgramChainNote } from "@/data/models/ProgramChainNote";
import {
  deleteProgramChainNote,
  observeProgramChainNotes,
} from "@/data/repository/ProgramChainNotesRepository";
import { formatTimestampHoursMinutes } from "@/utils/DateFormatter";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
    "create-program-chain-note": CreateProgramChainNoteComponent,
  },
})
export default class ProgramChainNotesComponent extends Vue {
  subscriptions: Array<() => void> = [];

  notes: ProgramChainNote[] = [];

  @Ref("confirmationDialog")
  confirmationDialog!: ConfirmationDialogComponent;

  @Prop()
  programChain!: ProgramChain;

  showCreateNewNoteComponent = true;
  observedProgramChainId: string | null = null;

  getNoteMetaData(programChainNote: ProgramChainNote) {
    const createdAt = formatTimestampHoursMinutes(programChainNote.createdAt);
    const createdBy = programChainNote.createdByUserNickname;

    return createdBy ? `${createdAt} / ${createdBy}` : createdAt;
  }

  mounted() {
    if (!this.programChain?.numNotes) {
      return;
    }

    this.observeProgramChainNotes();
  }

  observeProgramChainNotes() {
    const chainToObserve = this.programChain;
    if (this.observedProgramChainId === chainToObserve.id) {
      return;
    }

    this.observedProgramChainId = chainToObserve.id;
    this.clearSubscriptions();

    this.subscriptions.push(
      observeProgramChainNotes(chainToObserve.id, (notes) => {
        this.notes = notes;
      })
    );
  }

  clearSubscriptions() {
    this.subscriptions.forEach((subscription) => subscription());
    this.subscriptions = [];
  }

  onNoteCreated(note: ProgramChainNote) {
    this.observeProgramChainNotes();
    this.$emit("noteCreated", note);
  }

  async beforeDestroy() {
    this.clearSubscriptions();
  }

  async onDeleteNote(note: ProgramChainNote) {
    const didConfirmNoteDeletion = await this.confirmationDialog.show({
      title: this.$t(
        "programChainNote.deleteNoteConfirmationDialogTitle"
      ).toString(),
      message: this.$t(
        "programChainNote.deleteNoteConfirmationDialogMessage"
      ).toString(),
      acceptMessage: this.$t("common.yes").toString(),
    });

    if (didConfirmNoteDeletion) {
      await deleteProgramChainNote(note);
      this.$emit("noteDeleted", note);
    }
  }
}
